import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

const CookiePolicyPage = () => {
  useEffect(() => {
    document.title = 'Çerez Politikası | Karşıyaka Visa Consulting';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Karşıyaka Visa Consulting Çerez Politikası. Web sitemizde kullanılan çerezler ve veri toplama yöntemleri hakkında detaylı bilgi.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        <section className="py-20 bg-cream-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
              <div className="mb-8">
                <Link to="/" className="inline-flex items-center text-navy-600 hover:text-navy-900 transition-colors mb-6 text-sm">
                  <i className="ri-arrow-left-line mr-2"></i>
                  Ana Sayfaya Dön
                </Link>
                <h1 className="font-display text-4xl md:text-5xl font-bold text-navy-900 mb-4">
                  Çerez Politikası
                </h1>
                <p className="text-navy-600">
                  Son Güncelleme: 1 Ocak 2025
                </p>
              </div>

              <div className="prose prose-navy max-w-none space-y-8 text-navy-700 leading-relaxed">
                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">1. Çerez Politikası Hakkında</h2>
                  <p>
                    Bu Çerez Politikası, <strong>Karşıyaka Visa Consulting</strong> (karsiyakavisaconsulting.com.tr) web sitesinde 
                    kullanılan çerezler ve benzeri teknolojiler hakkında sizi bilgilendirmek amacıyla hazırlanmıştır. 
                    İzmir vize danışmanlığı hizmetlerimizi sunarken, web sitemizin işlevselliğini artırmak ve kullanıcı 
                    deneyimini iyileştirmek için çerezler kullanmaktayız.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">2. Çerez Nedir?</h2>
                  <p>
                    Çerezler, bir web sitesini ziyaret ettiğinizde tarayıcınız aracılığıyla cihazınıza (bilgisayar, tablet, 
                    akıllı telefon vb.) kaydedilen küçük metin dosyalarıdır. Çerezler, web sitesinin daha verimli çalışmasını 
                    sağlar ve site sahiplerine bilgi sağlar. Çerezler, kullanıcı deneyimini geliştirmek, site trafiğini 
                    analiz etmek ve kişiselleştirilmiş içerik sunmak için kullanılır.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">3. Çerez Türleri</h2>
                  
                  <h3 className="font-display text-xl font-semibold text-navy-900 mb-3 mt-6">3.1. Süreye Göre Çerezler</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>
                      <strong>Oturum Çerezleri (Session Cookies):</strong> Tarayıcınızı kapattığınızda otomatik olarak silinen 
                      geçici çerezlerdir. Web sitesinin temel işlevlerini yerine getirmek için kullanılır.
                    </li>
                    <li>
                      <strong>Kalıcı Çerezler (Persistent Cookies):</strong> Belirli bir süre boyunca veya siz silene kadar 
                      cihazınızda kalan çerezlerdir. Tercihlerinizi hatırlamak ve kullanıcı deneyimini iyileştirmek için kullanılır.
                    </li>
                  </ul>

                  <h3 className="font-display text-xl font-semibold text-navy-900 mb-3 mt-6">3.2. Amaca Göre Çerezler</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>
                      <strong>Zorunlu Çerezler:</strong> Web sitesinin temel işlevlerini yerine getirmesi için gerekli olan çerezlerdir. 
                      Bu çerezler olmadan site düzgün çalışmaz.
                    </li>
                    <li>
                      <strong>Performans Çerezleri:</strong> Web sitesinin performansını ölçmek ve iyileştirmek için kullanılan çerezlerdir. 
                      Ziyaretçi sayısı, sayfa görüntülemeleri gibi istatistiksel bilgiler toplar.
                    </li>
                    <li>
                      <strong>İşlevsellik Çerezleri:</strong> Tercihlerinizi hatırlayarak size daha kişiselleştirilmiş bir deneyim 
                      sunmak için kullanılan çerezlerdir.
                    </li>
                    <li>
                      <strong>Hedefleme/Reklam Çerezleri:</strong> İlgi alanlarınıza uygun reklamlar göstermek için kullanılan çerezlerdir.
                    </li>
                  </ul>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">4. Web Sitemizde Kullanılan Çerezler</h2>
                  <p>
                    İzmir vize danışmanlığı hizmetlerimizi sunarken, web sitemizde aşağıdaki çerez türlerini kullanmaktayız:
                  </p>

                  <div className="bg-cream-50 rounded-xl p-6 mt-4 space-y-4">
                    <div>
                      <h4 className="font-semibold text-navy-900 mb-2">Zorunlu Çerezler</h4>
                      <p className="text-sm">
                        Web sitesinin temel işlevlerini yerine getirmek için gerekli çerezler. Oturum yönetimi, 
                        güvenlik ve form gönderimi için kullanılır.
                      </p>
                    </div>

                    <div>
                      <h4 className="font-semibold text-navy-900 mb-2">Analitik Çerezler</h4>
                      <p className="text-sm">
                        Web sitesi trafiğini analiz etmek, ziyaretçi davranışlarını anlamak ve site performansını 
                        iyileştirmek için kullanılır. Google Analytics gibi araçlar kullanılabilir.
                      </p>
                    </div>

                    <div>
                      <h4 className="font-semibold text-navy-900 mb-2">İşlevsellik Çerezleri</h4>
                      <p className="text-sm">
                        Dil tercihiniz, bölge ayarlarınız gibi tercihlerinizi hatırlamak için kullanılır.
                      </p>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">5. Çerezlerin Kullanım Amaçları</h2>
                  <p>
                    Web sitemizde çerezleri aşağıdaki amaçlarla kullanmaktayız:
                  </p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li>Web sitesinin düzgün çalışmasını sağlamak</li>
                    <li>Kullanıcı deneyimini iyileştirmek ve kişiselleştirmek</li>
                    <li>Site trafiğini ve kullanıcı davranışlarını analiz etmek</li>
                    <li>Güvenlik önlemlerini uygulamak</li>
                    <li>Tercihlerinizi hatırlamak (dil, bölge vb.)</li>
                    <li>İletişim formlarının düzgün çalışmasını sağlamak</li>
                    <li>İzmir vize danışmanlığı hizmetlerimizi geliştirmek</li>
                    <li>Yasal yükümlülüklerimizi yerine getirmek</li>
                  </ul>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">6. Üçüncü Taraf Çerezleri</h2>
                  <p>
                    Web sitemizde, üçüncü taraf hizmet sağlayıcıların çerezleri de kullanılabilir. Bu çerezler, 
                    aşağıdaki hizmetler için kullanılabilir:
                  </p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li>
                      <strong>Google Analytics:</strong> Web sitesi trafiğini analiz etmek ve kullanıcı davranışlarını 
                      anlamak için kullanılır.
                    </li>
                    <li>
                      <strong>Google Maps:</strong> Ofis konumumuzu göstermek için kullanılır.
                    </li>
                    <li>
                      <strong>WhatsApp:</strong> İletişim widget'ı için kullanılabilir.
                    </li>
                    <li>
                      <strong>Sosyal Medya Platformları:</strong> İçerik paylaşımı ve sosyal medya entegrasyonu için kullanılabilir.
                    </li>
                  </ul>
                  <p className="mt-4">
                    Bu üçüncü taraf çerezler, ilgili hizmet sağlayıcıların gizlilik politikalarına tabidir.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">7. Çerezleri Kontrol Etme ve Silme</h2>
                  <p>
                    Çerezleri kontrol etme ve yönetme konusunda tam kontrole sahipsiniz. Çerezleri aşağıdaki yöntemlerle 
                    yönetebilirsiniz:
                  </p>

                  <h3 className="font-display text-xl font-semibold text-navy-900 mb-3 mt-6">7.1. Tarayıcı Ayarları</h3>
                  <p>
                    Çoğu tarayıcı, çerezleri otomatik olarak kabul edecek şekilde ayarlanmıştır. Tarayıcı ayarlarınızdan 
                    çerezleri engelleyebilir, mevcut çerezleri silebilir veya çerez kabul etmeden önce uyarı alacak şekilde 
                    ayarlayabilirsiniz.
                  </p>

                  <div className="bg-cream-50 rounded-xl p-6 mt-4 space-y-3">
                    <p className="font-semibold text-navy-900">Popüler Tarayıcılarda Çerez Ayarları:</p>
                    <ul className="list-disc pl-6 space-y-1 text-sm">
                      <li><strong>Google Chrome:</strong> Ayarlar &gt; Gizlilik ve güvenlik &gt; Çerezler ve diğer site verileri</li>
                      <li><strong>Mozilla Firefox:</strong> Ayarlar &gt; Gizlilik ve Güvenlik &gt; Çerezler ve Site Verileri</li>
                      <li><strong>Safari:</strong> Tercihler &gt; Gizlilik &gt; Çerezler ve web sitesi verileri</li>
                      <li><strong>Microsoft Edge:</strong> Ayarlar &gt; Gizlilik, arama ve hizmetler &gt; Çerezler ve site izinleri</li>
                    </ul>
                  </div>

                  <h3 className="font-display text-xl font-semibold text-navy-900 mb-3 mt-6">7.2. Çerezleri Reddetmenin Sonuçları</h3>
                  <p>
                    Çerezleri engellerseniz veya silerseniz, web sitemizin bazı özellikleri düzgün çalışmayabilir. 
                    Özellikle zorunlu çerezlerin engellenmesi, sitenin temel işlevlerini etkileyebilir.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">8. Çerez Politikası Güncellemeleri</h2>
                  <p>
                    Bu Çerez Politikası, yasal düzenlemelerdeki değişiklikler veya web sitemizdeki güncellemeler 
                    doğrultusunda zaman zaman güncellenebilir. Güncellemeler, bu sayfada yayınlanacak ve "Son Güncelleme" 
                    tarihi değiştirilecektir. Düzenli olarak bu sayfayı ziyaret ederek güncel bilgilere ulaşabilirsiniz.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">9. Kişisel Verilerin Korunması</h2>
                  <p>
                    Çerezler aracılığıyla toplanan kişisel verileriniz, 6698 sayılı Kişisel Verilerin Korunması Kanunu 
                    ("KVKK") kapsamında korunmaktadır. Kişisel verilerinizin işlenmesi hakkında detaylı bilgi için 
                    <Link to="/kvkk" className="text-navy-900 font-semibold hover:underline"> KVKK Aydınlatma Metni</Link>'ni 
                    inceleyebilirsiniz.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">10. Rıza ve Onay</h2>
                  <p>
                    Web sitemizi kullanmaya devam ederek, bu Çerez Politikası'nda belirtilen şartları kabul etmiş olursunuz. 
                    Zorunlu olmayan çerezler için açık rızanız alınacaktır. Rızanızı istediğiniz zaman geri çekebilirsiniz.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">11. İletişim</h2>
                  <p>
                    Çerez Politikası ile ilgili sorularınız veya çerezlerin kullanımı hakkında daha fazla bilgi almak için 
                    bizimle iletişime geçebilirsiniz:
                  </p>
                  <div className="bg-cream-50 rounded-xl p-6 mt-4">
                    <p><strong>Karşıyaka Visa Consulting</strong></p>
                    <p>Adres: Tuna Mah. Kemalpaşa Cad. Kat:5/506 Ses İş Hanı Karşıyaka / İzmir</p>
                    <p>Telefon: +90 551 480 3007</p>
                    <p>E-posta: karsiyakavisaconsulting@gmail.com</p>
                    <p>Web: karsiyakavisaconsulting.com.tr</p>
                  </div>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">12. Faydalı Bağlantılar</h2>
                  <p>
                    Çerezler ve çevrimiçi gizlilik hakkında daha fazla bilgi için aşağıdaki kaynaklara başvurabilirsiniz:
                  </p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li>Kişisel Verileri Koruma Kurumu: <a href="https://www.kvkk.gov.tr" target="_blank" rel="noopener noreferrer" className="text-navy-900 hover:underline">www.kvkk.gov.tr</a></li>
                    <li>All About Cookies: <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer" className="text-navy-900 hover:underline">www.allaboutcookies.org</a></li>
                  </ul>
                </section>

                <section className="border-t border-navy-200 pt-8 mt-8">
                  <p className="text-sm text-navy-600">
                    Bu Çerez Politikası, İzmir vize danışmanlığı hizmetlerimizi sunarken şeffaflık ve güven ilkelerimiz 
                    doğrultusunda hazırlanmıştır. Web sitemizi kullanarak, çerezlerin kullanımını kabul etmiş olursunuz.
                  </p>
                </section>
              </div>

              <div className="mt-12 pt-8 border-t border-navy-200">
                <Link
                  to="/"
                  className="inline-flex items-center text-navy-900 font-semibold hover:text-navy-700 transition-colors whitespace-nowrap"
                >
                  <i className="ri-arrow-left-line mr-2"></i>
                  Ana Sayfaya Dön
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default CookiePolicyPage;